// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sem-rush-report h2{
    font-size: 25px;
    font-weight: bold;
	color:#333333;
	margin-bottom:15px;
}

.sem-rush-report h3{
    font-size: 18px;
    font-weight: bold;
	color:#333333;
}

.crawled-page h2{
    font-size: 40px;
    margin: 15px 0px;
}

.text-blue{
    color: #2b94e1;
}

.badge{
    background: #2b94e1;
    color: #fff;
    padding: 2px 5px;
    display: -webkit-inline-box;
    font-size: 12px;
    border-radius: 3px;
    bottom: 4px;
    position: relative;
    margin-left: 5px;
}

.issues{
    overflow: auto;
    margin: 15px 0px;
    float: left;
    width: 100%;
}

.text-light-grey{
    color:#999;
}

.small{
    font-size: 75%;
}

.text-green{
    color: #2ba800;
}

.score{
    font-size: 35px;
    font-weight: bold;
}

.circle-sm{
    width: 10px; height: 10px; border-radius: 50%; float: left; margin: 6px 5px 5px 5px;
}

.bg-green{
    background: #2ba800;
}

.bg-disabled{
    background: #cccccc;
}

.bg-grey{
    background: #999;
}

.progress-bar{
    width:100%; height:15px; display:block; background:#eee; position:relative;
}

.pb-data{
    float: left; height:15px; 
}

.table.table-sem td, .table.table-sem th{ border-right: 1px solid #dee2e6;}
.table.table-sem tr:last-child{border-bottom: 1px solid #dee2e6;}

/****************************** SERP Features - Glossary css***************************************/
.max-1200{max-width:1200px;}
.serp-features-glossary.main-heading{font-size:23px; font-weight:700; margin-bottom:20px;}
.serp-features-glossary .highlight-text p{font-size:18px; line-height:26px; font-weight:600; margin-bottom:25px}
.feature-infomation-bx .serps{margin-bottom:25px; line-height:22px;}
.feature-infomation-bx .serps:last-child{margin-bottom:0;}
.feature-infomation-bx .serps label{float:left; margin:0 7px; font-weight:700;}
.feature-infomation-bx .icn{width:20px; height:20px; float:left; background-position:center center; background-repeat:no-repeat; display:inline-block; background-size: 100%; }
.serps .icn.feature-snippets{background-image:url(/assets/images/SEMrush/fs.svg);}
.serps .icn.local-pack{background-image:url(/assets/images/SEMrush/geo.svg);}
.serps .icn.reviews{background-image:url(/assets/images/SEMrush/rev.svg);}
.serps .icn.amp{background-image:url(/assets/images/SEMrush/dummy.svg);}
.serps .icn.sitelinks{background-image:url(/assets/images/SEMrush/stl.svg);}
.serps .icn.video{background-image:url(/assets/images/SEMrush/vid.svg);}
.serps .icn.featured-video{background-image:url(/assets/images/SEMrush/fv.svg);}
.serps .icn.top-stories{background-image:url(/assets/images/SEMrush/ts.svg);}
.serps .icn.people-also-ask{background-image:url(/assets/images/SEMrush/rel.svg);}
.serps .icn.images{background-image:url(/assets/images/SEMrush/img.svg);}
.serps .icn.twitter{background-image:url(/assets/images/SEMrush/twitter.svg);}
.serps .icn.instant-answer{background-image:url(/assets/images/SEMrush/ia.svg);}
.serps .icn.knowledge-panel{background-image:url(/assets/images/SEMrush/kng.svg);}
.serps .icn.shopping-ads{background-image:url(/assets/images/SEMrush/shp.svg);}
.serps .icn.aud-words-top{background-image:url(/assets/images/SEMrush/adt.svg);}
.serps .icn.aud-words-bottom{background-image:url(/assets/images/SEMrush/adb.svg);}

/****************************** SERP Features - Glossary css***************************************/`, "",{"version":3,"sources":["webpack://./src/app/components/reporting/sem-rush-report/sem-rush-report.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;CACpB,aAAa;CACb,kBAAkB;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;CACpB,aAAa;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,WAAW,EAAE,uBAAuB;AACvF;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU,EAAE,WAAW,EAAE,aAAa,EAAE,eAAe,EAAE,iBAAiB;AAC9E;;AAEA;IACI,WAAW,EAAE,WAAW;AAC5B;;AAEA,0CAA0C,+BAA+B,CAAC;AAC1E,+BAA+B,gCAAgC,CAAC;;AAEhE,mGAAmG;AACnG,UAAU,gBAAgB,CAAC;AAC3B,qCAAqC,cAAc,EAAE,eAAe,EAAE,kBAAkB,CAAC;AACzF,0CAA0C,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,kBAAkB;AAC/G,8BAA8B,kBAAkB,EAAE,gBAAgB,CAAC;AACnE,yCAAyC,eAAe,CAAC;AACzD,oCAAoC,UAAU,EAAE,YAAY,EAAE,eAAe,CAAC;AAC9E,4BAA4B,UAAU,EAAE,WAAW,EAAE,UAAU,EAAE,iCAAiC,EAAE,2BAA2B,EAAE,oBAAoB,EAAE,qBAAqB,EAAE;AAC9K,6BAA6B,mDAAmD,CAAC;AACjF,uBAAuB,oDAAoD,CAAC;AAC5E,oBAAoB,oDAAoD,CAAC;AACzE,gBAAgB,sDAAsD,CAAC;AACvE,sBAAsB,oDAAoD,CAAC;AAC3E,kBAAkB,oDAAoD,CAAC;AACvE,2BAA2B,mDAAmD,CAAC;AAC/E,wBAAwB,mDAAmD,CAAC;AAC5E,4BAA4B,oDAAoD,CAAC;AACjF,mBAAmB,oDAAoD,CAAC;AACxE,oBAAoB,wDAAwD,CAAC;AAC7E,2BAA2B,mDAAmD,CAAC;AAC/E,4BAA4B,oDAAoD,CAAC;AACjF,yBAAyB,oDAAoD,CAAC;AAC9E,0BAA0B,oDAAoD,CAAC;AAC/E,6BAA6B,oDAAoD,CAAC;;AAElF,mGAAmG","sourcesContent":[".sem-rush-report h2{\n    font-size: 25px;\n    font-weight: bold;\n\tcolor:#333333;\n\tmargin-bottom:15px;\n}\n\n.sem-rush-report h3{\n    font-size: 18px;\n    font-weight: bold;\n\tcolor:#333333;\n}\n\n.crawled-page h2{\n    font-size: 40px;\n    margin: 15px 0px;\n}\n\n.text-blue{\n    color: #2b94e1;\n}\n\n.badge{\n    background: #2b94e1;\n    color: #fff;\n    padding: 2px 5px;\n    display: -webkit-inline-box;\n    font-size: 12px;\n    border-radius: 3px;\n    bottom: 4px;\n    position: relative;\n    margin-left: 5px;\n}\n\n.issues{\n    overflow: auto;\n    margin: 15px 0px;\n    float: left;\n    width: 100%;\n}\n\n.text-light-grey{\n    color:#999;\n}\n\n.small{\n    font-size: 75%;\n}\n\n.text-green{\n    color: #2ba800;\n}\n\n.score{\n    font-size: 35px;\n    font-weight: bold;\n}\n\n.circle-sm{\n    width: 10px; height: 10px; border-radius: 50%; float: left; margin: 6px 5px 5px 5px;\n}\n\n.bg-green{\n    background: #2ba800;\n}\n\n.bg-disabled{\n    background: #cccccc;\n}\n\n.bg-grey{\n    background: #999;\n}\n\n.progress-bar{\n    width:100%; height:15px; display:block; background:#eee; position:relative;\n}\n\n.pb-data{\n    float: left; height:15px; \n}\n\n.table.table-sem td, .table.table-sem th{ border-right: 1px solid #dee2e6;}\n.table.table-sem tr:last-child{border-bottom: 1px solid #dee2e6;}\n\n/****************************** SERP Features - Glossary css***************************************/\n.max-1200{max-width:1200px;}\n.serp-features-glossary.main-heading{font-size:23px; font-weight:700; margin-bottom:20px;}\n.serp-features-glossary .highlight-text p{font-size:18px; line-height:26px; font-weight:600; margin-bottom:25px}\n.feature-infomation-bx .serps{margin-bottom:25px; line-height:22px;}\n.feature-infomation-bx .serps:last-child{margin-bottom:0;}\n.feature-infomation-bx .serps label{float:left; margin:0 7px; font-weight:700;}\n.feature-infomation-bx .icn{width:20px; height:20px; float:left; background-position:center center; background-repeat:no-repeat; display:inline-block; background-size: 100%; }\n.serps .icn.feature-snippets{background-image:url(/assets/images/SEMrush/fs.svg);}\n.serps .icn.local-pack{background-image:url(/assets/images/SEMrush/geo.svg);}\n.serps .icn.reviews{background-image:url(/assets/images/SEMrush/rev.svg);}\n.serps .icn.amp{background-image:url(/assets/images/SEMrush/dummy.svg);}\n.serps .icn.sitelinks{background-image:url(/assets/images/SEMrush/stl.svg);}\n.serps .icn.video{background-image:url(/assets/images/SEMrush/vid.svg);}\n.serps .icn.featured-video{background-image:url(/assets/images/SEMrush/fv.svg);}\n.serps .icn.top-stories{background-image:url(/assets/images/SEMrush/ts.svg);}\n.serps .icn.people-also-ask{background-image:url(/assets/images/SEMrush/rel.svg);}\n.serps .icn.images{background-image:url(/assets/images/SEMrush/img.svg);}\n.serps .icn.twitter{background-image:url(/assets/images/SEMrush/twitter.svg);}\n.serps .icn.instant-answer{background-image:url(/assets/images/SEMrush/ia.svg);}\n.serps .icn.knowledge-panel{background-image:url(/assets/images/SEMrush/kng.svg);}\n.serps .icn.shopping-ads{background-image:url(/assets/images/SEMrush/shp.svg);}\n.serps .icn.aud-words-top{background-image:url(/assets/images/SEMrush/adt.svg);}\n.serps .icn.aud-words-bottom{background-image:url(/assets/images/SEMrush/adb.svg);}\n\n/****************************** SERP Features - Glossary css***************************************/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
